( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '#start-form-btn' ).on( 'click', function() {
        $( 'body' ).addClass( 'mpf__show-form' );
      } );

      $( document ).on( 'gform_page_loaded', function( event, formId, page ) {
        if ( page == $( '.gform_page' ).length ) {
          $( '#mpf__progress-footer' ).hide();
        } else {
          $( '#mpf__progress-footer' ).show();
        }
      } );

      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        $( 'body' ).addClass( 'mpf__is-confirmation' );
        $( '.gform_confirmation_message' ).addClass( 'wysiwyg theme-one' );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'multipage-form', COMPONENT );
} )( app );
